/* AU Ship: the ONE copy of the storefront delivery schedule (William,
   Sep 30): 1 PM Eastern business-day cutoff, carrier holidays, next-day
   arrival, economy = ship + 5 business days. Used by the PDP delivery
   certificate and the customize fee bar (window.__auShip), and by the
   in-cart edit popup (assets/au-easify.js). Loaded synchronously in
   <head> so inline section scripts can call it immediately. */
(function () {
  var WDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var fmt = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/New_York',
    weekday: 'short',
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    hour12: false
  });

  function addDays(d, n) {
    var x = new Date(d);
    x.setDate(x.getDate() + n);
    return x;
  }

  /* Federal holidays carriers observe, so business-day math skips them.
     Mirrors the checkout shipping engine so the storefront promised date
     and the checkout date never disagree (added 2026-08-06). */
  function isHoliday(d) {
    var y = d.getFullYear();
    var key = function (t) { return t.getFullYear() + '-' + t.getMonth() + '-' + t.getDate(); };
    var set = {};
    var fixed = function (mo, day) {
      var t = new Date(y, mo, day), wd = t.getDay();
      set[key(t)] = 1;
      if (wd === 6) set[key(new Date(y, mo, day - 1))] = 1;
      else if (wd === 0) set[key(new Date(y, mo, day + 1))] = 1;
    };
    var nth = function (mo, wd, n) {
      var first = new Date(y, mo, 1).getDay();
      return new Date(y, mo, 1 + ((wd - first + 7) % 7) + (n - 1) * 7);
    };
    var lastMon = function (mo) {
      var ld = new Date(y, mo + 1, 0);
      return new Date(y, mo, ld.getDate() - ((ld.getDay() - 1 + 7) % 7));
    };
    fixed(0, 1);                 // New Year's Day
    set[key(lastMon(4))] = 1;    // Memorial Day (last Mon May)
    fixed(6, 4);                 // Independence Day
    set[key(nth(8, 1, 1))] = 1;  // Labor Day (1st Mon Sep)
    set[key(nth(10, 4, 4))] = 1; // Thanksgiving (4th Thu Nov)
    fixed(11, 25);               // Christmas
    return !!set[key(d)];
  }

  function nextBizDay(d) {
    var x = addDays(d, 1);
    while (x.getDay() === 0 || x.getDay() === 6 || isHoliday(x)) x = addDays(x, 1);
    return x;
  }


  function compute() {
    /* Eastern wall time, DST-safe via Intl. */
    var p = {};
    fmt.formatToParts(new Date()).forEach(function (part) {
      p[part.type] = part.value;
    });
    var dow = WDAYS.indexOf(p.weekday);
    var hour = parseInt(p.hour, 10) % 24;
    var min = parseInt(p.minute, 10);
    /* Naive date carrying the Eastern calendar day; used only for
       day arithmetic and labels, never re-read as an instant. */
    var today = new Date(+p.year, +p.month - 1, +p.day);
    var isBizDay = dow >= 1 && dow <= 5 && !isHoliday(today);
    var beforeCutoff = isBizDay && hour < 13;
    var shipDate = beforeCutoff ? today : nextBizDay(today);
    var arriveDate = nextBizDay(shipDate);

    var isTomorrow = shipDate.getTime() === addDays(today, 1).getTime();
    var shipDayName = beforeCutoff
      ? 'today'
      : isTomorrow
        ? 'tomorrow'
        : shipDate.toLocaleDateString('en-US', { weekday: 'long' });
    var dayGap = Math.round((shipDate.getTime() - today.getTime()) / 86400000);
    var minsLeft = dayGap * 1440 + 13 * 60 - (hour * 60 + min);
    var ecoDate = shipDate;
    for (var k = 0; k < 5; k++) ecoDate = nextBizDay(ecoDate);
    return { shipDayName: shipDayName, minsLeft: minsLeft, shipDate: shipDate, arriveDate: arriveDate, ecoDate: ecoDate, beforeCutoff: beforeCutoff };
  }

  window.AUShip = { compute: compute, nextBizDay: nextBizDay, addDays: addDays, isHoliday: isHoliday };
})();
